/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_AnswerInputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not necessarily. The person building a report may need capabilities that a reader does not. Decide based on editing, automation and handoff requirements for each role. A shared standard can simplify support, but it should follow the real workflow rather than a general claim that one app is best for everyone.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不一定。制作报表的人可能需要阅读者不需要的能力。应按角色分别考虑编辑、自动化和交付需求。统一标准可以简化支持，但标准应来自实际工作流程，而不是“某款应用适合所有人”的笼统判断。`)
};

/**
* | output |
* | --- |
* | "Not necessarily. The person building a report may need capabilities that a reader does not. Decide based on editing, automation and handoff requirements for ..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_7_Questions_4_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_answer(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_answer(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_7_questions_4_answer as "gc.search_guides.gridcraft_vs_excel.sections.7.questions.4.answer" }